import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
import { useReportWebVitals } from "next/web-vitals";
import { reportWebVital, reportedRoute } from "@/lib/reportWebVital";
const REPORTED_VITALS = ["INP", "LCP", "TTFB", "FCP", "CLS"];
const DOCUMENT_LOAD_VITALS = ["LCP", "FCP", "TTFB"];

/**
 * Reports the page's web vitals to `/frontend/metrics`, using the document-start
 * route for load vitals and the current route for lifetime vitals.
 *
 * web-vitals emits INP and CLS when the page is first hidden (tab switch,
 * close) and again on later hides if the value grew; only the first emission
 * per metric id is reported, since a Prometheus histogram cannot retract the
 * earlier sample.
 */
export function useWebVitalsReporting() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Set();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const reportedIds = useRef(t0);
  const [documentRoute] = useState(_temp);
  let t1;
  if ($[1] !== documentRoute) {
    t1 = metric => {
      if (!REPORTED_VITALS.includes(metric.name)) {
        return;
      }
      if (reportedIds.current.has(metric.id)) {
        return;
      }
      reportedIds.current.add(metric.id);
      const route = DOCUMENT_LOAD_VITALS.includes(metric.name) ? documentRoute : reportedRoute();
      if (route) {
        reportWebVital(metric.name, metric.value, route);
      }
    };
    $[1] = documentRoute;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useReportWebVitals(t1);
}
function _temp() {
  return typeof window !== "undefined" ? reportedRoute() : null;
}